import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const EmailBodyPreview = ({ body, row, handleViewDetails }) => {
  const { t } = useTranslation();
  const charLimit = 70;
  const shortText =
    body.length > charLimit ? body.substring(0, charLimit) + "..." : body;

  return (
    <div>
      {shortText}
      {body.length > charLimit && (
        <span
          onClick={() => handleViewDetails(row)}
          style={{ color: "blue", cursor: "pointer", marginLeft: "5px" }}
        >
          {t(`Email.Read More`)}
        </span>
      )}
    </div>
  );
};

export default EmailBodyPreview;
